import React, { useState, useEffect } from "react";
import { DirectDataImportModal } from "./DirectDataImportModal";

/**
 * Mounts globally and watches the URL for redirect-style OAuth returns
 * (?externalConnectionResult=...&provider=...). When detected, opens the
 * DirectDataImport modal so the user lands back on the integration tile they
 * were configuring. DataSourceSelector reads the same params and auto-selects
 * the provider; IntercomInterface reads them to refetch status and clean the URL.
 *
 * Popup-based OAuth providers (e.g. Zoom — see BaseOAuthInterface) don't trigger
 * this path: their parent page never navigates away, so the URL stays clean.
 *
 * The /integrations route opts out of this handler — that page owns its own
 * OAuth-return UX (custom-built Integrations Settings modal, see SM_Integrations).
 */
const ROUTES_THAT_OWN_OAUTH_RETURN = ["/integrations"];

export const DirectDataImportOAuthReturnHandler = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (ROUTES_THAT_OWN_OAUTH_RETURN.includes(window.location.pathname)) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get("externalConnectionResult") && params.get("provider")) {
      setIsOpen(true);
    }
  }, []);

  return <DirectDataImportModal isOpen={isOpen} onClose={() => setIsOpen(false)} />;
};

export default DirectDataImportOAuthReturnHandler;
